(function () {
  var PRICES = {
    1: { sale: 22.99, discount: 23, interval: 'every month', underline: false },
    2: { sale: 19.99, discount: 33, interval: 'every 2 months', underline: true },
    3: { sale: 18.99, discount: 37, interval: 'every 3 months', underline: true }
  };
  var ONCE_PRICES = {
    1: { sale: 24.99 },
    2: { sale: 22.99 },
    3: { sale: 21.99 }
  };
  var BASE_PRICE = 29.99;

  function removeStorefrontLocalization() {
    var selectors = [
      '.desktop-localization-wrapper',
      '.footer__localization',
      '#HeaderCountryForm',
      '#HeaderLanguageForm',
      '#FooterCountryForm',
      '#FooterLanguageForm',
      'localization-form',
      '#shopify-pc__banner',
      '.shopify-pc__banner',
      '.shopify-pc__banner__dialog',
      '.shopify-pc__prefs',
      'shopify-privacy-banner',
      '[data-shopify-privacy-banner]',
      '[id*="shopify-pc"]',
      '[class*="shopify-pc"]'
    ];
    selectors.forEach(function (selector) {
      Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(function (element) {
        element.remove();
      });
    });
  }

  function money(value) {
    return '$' + Number(value).toFixed(2);
  }

  function initProduct(root) {
    var selectedJar = 2;
    var mode = 'subscribe';
    var variantId = root.dataset.variantId;
    var form = root.querySelector('[data-scp-form]');
    var quantityInput = root.querySelector('[data-scp-quantity]');
    var planInput = root.querySelector('[data-scp-selling-plan]');
    var qtyDisplay = root.querySelector('[data-scp-qty-display]');
    var discountBadge = root.querySelector('[data-scp-discount]');
    var cartDiscount = root.querySelector('[data-scp-cart-discount]');
    var bulletDiscount = root.querySelector('[data-scp-bullet-discount]');
    var subPrice = root.querySelector('[data-scp-sub-price]');
    var oncePrice = root.querySelector('[data-scp-once-price]');
    var shipBullet = root.querySelector('[data-scp-ship-bullet]');
    var jarRadios = Array.prototype.slice.call(root.querySelectorAll('[data-scp-jar]'));
    var modeRadios = Array.prototype.slice.call(root.querySelectorAll('[data-scp-mode]'));
    var jarCards = Array.prototype.slice.call(root.querySelectorAll('[data-scp-jar-card]'));
    var subscribeCard = root.querySelector('[data-scp-subscribe-card]');
    var onceCard = root.querySelector('[data-scp-once-card]');

    function getPlanId(jars) {
      return root.getAttribute('data-selling-plan-' + jars) || '';
    }

    function getOnceVariantId(jars) {
      return root.getAttribute('data-once-variant-' + jars) || variantId;
    }

    function setPlanInput() {
      var planId = mode === 'subscribe' ? getPlanId(selectedJar) : '';
      if (planId) {
        planInput.disabled = false;
        planInput.value = planId;
      } else {
        planInput.value = '';
        planInput.disabled = true;
      }
    }

    function sync() {
      var data = PRICES[selectedJar];
      var onceData = ONCE_PRICES[selectedJar];
      root.dataset.mode = mode;
      root.dataset.jars = String(selectedJar);
      quantityInput.value = String(selectedJar);
      if (qtyDisplay) qtyDisplay.textContent = String(selectedJar);
      discountBadge.textContent = 'Save ' + data.discount + '%';
      if (cartDiscount) cartDiscount.textContent = data.discount + '% Off';
      bulletDiscount.textContent = data.discount + '%';
      subPrice.textContent = money(data.sale) + ' each';
      if (oncePrice) oncePrice.textContent = money(onceData.sale) + ' each';
      shipBullet.innerHTML = 'Ships <span' + (data.underline ? '' : ' class="is-plain"') + '>' + data.interval + '</span>';
      jarCards.forEach(function (card) {
        var input = card.querySelector('[data-scp-jar]');
        var jars = Number(input.value);
        var basePrice = card.querySelector('.scp-base-price');
        var salePrice = card.querySelector('.scp-sale-price');
        var active = Number(input.value) === selectedJar;
        if (basePrice) basePrice.textContent = money(BASE_PRICE) + '/each';
        if (salePrice) salePrice.textContent = money(mode === 'once' ? ONCE_PRICES[jars].sale : PRICES[jars].sale) + '/each';
        card.classList.toggle('is-selected', active);
        input.checked = active;
      });
      subscribeCard.classList.toggle('is-selected', mode === 'subscribe');
      onceCard.classList.toggle('is-selected', mode === 'once');
      modeRadios.forEach(function (radio) {
        radio.checked = radio.value === mode;
      });
      setPlanInput();
    }

    jarRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        selectedJar = Number(radio.value);
        sync();
      });
    });

    modeRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        mode = radio.value;
        sync();
      });
    });

    var qtyMinus = root.querySelector('[data-scp-qty-minus]');
    var qtyPlus = root.querySelector('[data-scp-qty-plus]');
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        selectedJar = Math.max(1, selectedJar - 1);
        sync();
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        selectedJar = Math.min(3, selectedJar + 1);
        sync();
      });
    }

    form.addEventListener('submit', function () {
      quantityInput.value = String(selectedJar);
      form.querySelector('[name="id"]').value = mode === 'once' ? getOnceVariantId(selectedJar) : variantId;
      setPlanInput();
    });

    sync();
  }

  function initGallery(root) {
    var slidesWrap = root.querySelector('[data-scp-slides]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-scp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-scp-thumb]'));
    var current = root.querySelector('[data-scp-current]');
    var progress = root.querySelector('[data-scp-progress]');
    var prev = root.querySelector('[data-scp-gallery-prev]');
    var next = root.querySelector('[data-scp-gallery-next]');
    var active = 0;

    function setActive(index, scroll) {
      active = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach(function (slide, idx) {
        slide.classList.toggle('is-active', idx === active);
      });
      thumbs.forEach(function (thumb, idx) {
        thumb.classList.toggle('is-active', idx === active);
      });
      if (current) current.textContent = String(active + 1);
      if (progress) progress.style.width = ((active + 1) / Math.max(1, slides.length) * 100) + '%';
      if (scroll && slides[active]) slides[active].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        setActive(index, true);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        setActive((active - 1 + slides.length) % slides.length, false);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        setActive((active + 1) % slides.length, false);
      });
    }

    if (slidesWrap) {
      var ticking = false;
      var isDragging = false;
      var dragStartX = 0;
      var dragStartScrollLeft = 0;

      slidesWrap.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        isDragging = true;
        dragStartX = event.clientX;
        dragStartScrollLeft = slidesWrap.scrollLeft;
        slidesWrap.classList.add('is-dragging');
        if (slidesWrap.setPointerCapture) slidesWrap.setPointerCapture(event.pointerId);
      });

      slidesWrap.addEventListener('pointermove', function (event) {
        if (!isDragging) return;
        event.preventDefault();
        slidesWrap.scrollLeft = dragStartScrollLeft - (event.clientX - dragStartX);
      });

      function endDrag(event) {
        if (!isDragging) return;
        isDragging = false;
        slidesWrap.classList.remove('is-dragging');
        if (slidesWrap.releasePointerCapture) {
          try {
            slidesWrap.releasePointerCapture(event.pointerId);
          } catch (error) {}
        }
      }

      slidesWrap.addEventListener('pointerup', endDrag);
      slidesWrap.addEventListener('pointercancel', endDrag);
      slidesWrap.addEventListener('pointerleave', endDrag);

      slidesWrap.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var item = slides[0];
          if (!item) return;
          var gap = 8;
          var index = Math.round(slidesWrap.scrollLeft / (item.getBoundingClientRect().width + gap));
          setActive(index, false);
          ticking = false;
        });
      }, { passive: true });
    }

    setActive(0, false);
  }

  function initAccordions(root) {
    var details = Array.prototype.slice.call(root.querySelectorAll('.scp-accordions details'));
    details.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        details.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function initSubscribeModal(root) {
    var trigger = root.querySelector('[data-scp-sub-info]');
    var modal = root.querySelector('[data-scp-sub-modal]');
    if (!trigger || !modal) return;
    var closeButtons = Array.prototype.slice.call(modal.querySelectorAll('[data-scp-modal-close]'));
    var lastFocus = null;

    function openModal(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('scp-modal-open');
      var close = modal.querySelector('[data-scp-modal-close]');
      if (close) close.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('scp-modal-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    trigger.addEventListener('click', openModal);
    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') openModal(event);
    });
    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function initReviewScroll(root) {
    var trigger = root.querySelector('[data-scp-review-scroll]');
    if (!trigger) return;

    function findReviewsTarget() {
      return document.querySelector('.jdgm-review-widget') ||
        document.querySelector('.jdgm-widget:not(.jdgm-preview-badge)') ||
        document.querySelector('[id^="shopify-section-template--"][id*="__177931204779f08099"]');
    }

    trigger.addEventListener('click', function () {
      var target = findReviewsTarget();
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    removeStorefrontLocalization();
    window.setTimeout(removeStorefrontLocalization, 500);
    window.setTimeout(removeStorefrontLocalization, 1500);
    Array.prototype.slice.call(document.querySelectorAll('[data-scp-product]')).forEach(function (root) {
      initProduct(root);
      initGallery(root);
      initAccordions(root);
      initSubscribeModal(root);
      initReviewScroll(root);
    });
  });
})();
